import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { Contract } from "./Contract";
import { Demand } from "./Demand";
import { Restaurant } from "./Restaurant";
import { useTranslation } from "react-i18next";

const TabUpload = () => {
	const { t } = useTranslation();
	const [selectedTab, setSelectedTab] = useState("demand");

	const handleChange = (event, newValue) => {
		setSelectedTab(newValue);
	};
	const renderSelectedTabContent = () => {
		switch (selectedTab) {
			case "demand":
				return <Demand />;
			case "restaurant":
				return <Restaurant />;
			case "contract":
				return <Contract />;
			default:
				return null;
		}
	};

	return (
		<>
			<Box
				sx={{
					borderBottom: 1,
					borderColor: "secondary.main",
				}}
			>
				<Tabs textColor="primary" indicatorColor="primary" value={selectedTab} onChange={handleChange}>
					<Tab value="demand" label={t("upload.demand.title")} />
					<Tab value="restaurant" label={t("upload.site.title")} />
					<Tab value="contract" label={t("upload.contract.title")} />
				</Tabs>
			</Box>
			{renderSelectedTabContent()}
		</>
	);
};

export { TabUpload };
